import { render, staticRenderFns } from "./vip-club.vue?vue&type=template&id=f1f91d3c&scoped=true"
import script from "./vip-club.vue?vue&type=script&lang=js"
export * from "./vip-club.vue?vue&type=script&lang=js"
import style0 from "./vip-club.vue?vue&type=style&index=0&id=f1f91d3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f91d3c",
  null
  
)

export default component.exports